<template>
    <div class="easter-egg d-flex align-end justify-center flex-shrink-0" ref="easteregg">
        <div class="easter-egg__backdrop" :style="{ 'opacity': opacity }"></div>
        <div class="text-center content">
            <v-btn icon
                   class="mx-auto mb-3"
                   @click="scrollToTop"
                   color="primary">
                <v-icon>mdi-arrow-up-circle-outline</v-icon>
            </v-btn>
            <div class="text-uppercase body-2 mb-5">
                {{ $vuetify.lang.t('$vuetify.login.exclusive-by') }}
            </div>
            <v-img class="align-self-start ml-auto mr-auto"
                   :width="imageWidth"
                   :height="imageHeight"
                   contain
                   src="../assets/images/knaus_logo.svg"></v-img>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'easter-egg',
        data() {
            return {
                opacity: 1,
            };
        },
        computed: {
            imageWidth() {
                return this.$vuetify.breakpoint.smAndUp ? '190px' : '300px';
            },
            imageHeight() {
                return this.$vuetify.breakpoint.smAndUp ? '65px' : '42.5px';
            },
        },
        methods: {
            handleScroll(event) {
                const toolBar = document.querySelector('.v-toolbar');
                const bottomBarElement = document.querySelector('.v-bottom-navigation');
                const easterEggElement = this.$refs.easteregg;
                const windowBottomLine = window.scrollY + easterEggElement.scrollHeight - toolBar.scrollHeight;
                const beginOn = easterEggElement.offsetTop + bottomBarElement.scrollHeight;
                const endOn = easterEggElement.offsetTop + easterEggElement.scrollHeight + bottomBarElement.scrollHeight;
                this.opacity = 1 - ((windowBottomLine - beginOn) / (endOn - beginOn));
            },
            scrollToTop() {
              this.$vuetify.goTo(0);
            },
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        },
    }
</script>
